import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, DataListItem } from '@node-space/ui-components'
import { CustomerEntityType } from 'types/customers'
import { CustomerDetails } from '../types'

interface CustomerInfoProps {
  customerDetails: CustomerDetails
}

const CustomerInfo = ({ customerDetails }: CustomerInfoProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Box flexCol padding={16} gap={24}>
        <h2 className="text-h2 text-foreground-prominent">
          {customerDetails?.type == CustomerEntityType.COMPANY && t('customers.companyInfo')}
          {customerDetails?.type == CustomerEntityType.INDIVIDUAL && t('customers.individualInfo')}
        </h2>
        <Box flexCol align="center" gapY={12}>
          {customerDetails?.name && (
            <Avatar size="large" type="entity" name={customerDetails?.name || ''} />
          )}
          <h3 className="text-h3 text-foreground-prominent text-center">{customerDetails?.name}</h3>
        </Box>
      </Box>
      <Box padding={16} paddingT={8}>
        {customerDetails?.details &&
          Object.keys(customerDetails?.details)
            ?.filter(key => !!customerDetails?.details?.[key]?.trim())
            ?.map(key => (
              <DataListItem
                id={customerDetails?.name}
                key={customerDetails?.name}
                title={t(`customers.${key}`)}
                body={customerDetails?.details?.[key]}
                layout="vertical"
              />
            ))}
      </Box>
    </>
  )
}

export default CustomerInfo
